/* jshint esversion: 6 */
import React from 'react';
import ChooserHeader from 'app/components/SubaccountSelector/ChooserHeader.jsx';
import ChooserMain from 'app/components/SubaccountSelector/ChooserMain.jsx';

class NextdoorOutput extends React.Component {
    render() {
        return (
            <div>
                <ChooserHeader
                    {...this.props}
                    error={this.props.error}
                    headerCopy="Select a Nextdoor Page"/>
                <ChooserMain
                    {...this.props}
                    allConnectedMessage={(
                        <p className="chooser-notice">You've already connected all your Nextdoor Pages to dlvr.it</p>
                    )}
                    typeLabel="Nextdoor page"/>
            </div>
        );
    }
}

NextdoorOutput.displayName = "NextdoorOutput";

export default NextdoorOutput;
